'use client'

import { useRef } from 'react'

import FormRenderer from '@/components/common/Forms/FormRenderer'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { handleSubmitError } from '@/lib/form-submit-error-handler'

import type { FormType } from '@/types/contentful/formType'

export function HalfHalfBlockFormSection({ form }: { form: FormType }) {
  const formRef = useRef<HTMLDivElement>(null)
  const isDesktop = useMediaQuery('(min-width: 768px)') ?? false
  const src = form.fields?.formSchemaUrl

  if (!src) return null

  return (
    <div ref={formRef} className="w-full" id="half-half-block-form-section">
      <FormRenderer src={src} onError={() => handleSubmitError({ formRef, isDesktop })} />
    </div>
  )
}
